var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.404,
    height: 22.299,
    viewBox: "0 0 22.404 22.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#78849e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.637,24.811H13.455L25.637,12.655V23.242h1.569V11.086l2.876-2.9-.549-.549-3.059,3.059H14.683v1.569H24.9l-11.79,11.79V7.4H11.6v3.294H8.2v1.569h3.4V26.379H25.637V29.7h1.569v-3.32h3.4V24.811H25.637Z",
    transform: "translate(-8.2 -7.4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.6160d8290687f63f9026b4a8a75c4c64.svg";
export { ForwardRef as ReactComponent };